'use strict';

import { EventCodes } from '../../../../App/model/event-codes';

QuickFilterPreprocessorFactory.$inject = ['mx.SolutionBuilderAgent.BasePreprocessor', 'mx.shell.EventService'];
export default function QuickFilterPreprocessorFactory(BasePreprocessor, eventService) {
	function QuickFilterPreprocessor() {
		BasePreprocessor.apply(this);
		this.options = {};
		this.type = mx.SolutionBuilderAgent.PreprocessorType.QuickFilter;
		this.parts = 0;
		this.titles = {};
		this.filters = [];
		return this;
	}

	QuickFilterPreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		build: function () {
			return this.executor.quickFiltersBuild(this.options, this.filters);
		},

		load: function (_widgetId, dataQueryId, parameters) {
			this.options.red = parameters.redFilter;
			this.options.yellow = parameters.yellowFilter;
			this.options.green = parameters.greenFilter;
			this.parts = (this.options.red ? 1 : 0) | (this.options.yellow ? 2 : 0) | (this.options.green ? 4 : 0);
			this.titles = parameters.quickFilterTitles;
			this.filters = this.checkFilters(parameters.quickFilters);
			this.color = this.getColor(this.filters);
		},

		callChanged: function (color) {
			this.filters = [];
			this.color = color;
			var red = (color & 1) === 1 && this.options.red;
			var yellow = (color & 2) === 2 && this.options.yellow;
			var green = (color & 4) === 4 && this.options.green;
			if (red) {
				this.filters.push(red);
			}
			if (yellow) {
				this.filters.push(yellow);
			}
			if (green) {
				this.filters.push(green);
			}

			eventService.dispatchEvent(EventCodes.TrackTelemetry, {
				eventName: `Quick filter applied`,
				sender: this.parameters.id,
				senderTitle: this.parameters.name,
				contextTypeId: this.parameters.entities.map((entity) => entity.id),
				contextTypeTitle: this.parameters.entities.map((entity) => entity.name),
				contextId: this.filters,
			});

			this.changed();
		},

		resetFilters: function () {
			this.callChanged(0);
		},

		getFilters: function () {
			return {
				red: {
					active: (this.color & 1) === 1,
					title: this.titles.red,
					id: this.options.red,
				},
				yellow: {
					active: (this.color & 2) === 2,
					title: this.titles.yellow,
					id: this.options.yellow,
				},
				green: {
					active: (this.color & 4) === 4,
					title: this.titles.green,
					id: this.options.green,
				},
			};
		},

		checkFilters: function (quickFilters) {
			var result = [];

			(quickFilters || []).forEach(function (value) {
				if (value === this.options.red || value === this.options.yellow || value === this.options.green) {
					result.push(value);
				}
			}, this);

			return result;
		},

		getColor: function (filters) {
			if (!filters || !filters.length) {
				return 0;
			}

			return (
				(filters.indexOf(this.options.red) === -1 ? 0 : 1) | (filters.indexOf(this.options.yellow) === -1 ? 0 : 2) | (filters.indexOf(this.options.green) === -1 ? 0 : 4)
			);
		},
	});

	return QuickFilterPreprocessor;
}
